import { render, staticRenderFns } from "./Prologue.vue?vue&type=template&id=0b09486e&scoped=true"
import script from "./Prologue.vue?vue&type=script&lang=js"
export * from "./Prologue.vue?vue&type=script&lang=js"
import style0 from "./Prologue.vue?vue&type=style&index=0&id=0b09486e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b09486e",
  null
  
)

export default component.exports